import { adminFetch } from "./base";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface Region {
  readonly id: string;
  readonly name: string;
  readonly code: string;
  readonly active: boolean;
}

export interface RegionsListResponse {
  readonly regions: readonly Region[];
}

// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------

export const regionsApi = {
  /** List all regions (id + name + code). */
  list: () => adminFetch<RegionsListResponse>("/api/admin/regions"),
} as const;
